/* Keeps track of the current screen layout, including the full screen status */
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import fscreen from 'fscreen';
import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useFullScreenHandle } from 'react-full-screen';
import { MediaContext } from 'react-media-query-hoc';
var useScreenLayout = () => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var screen = useFullScreenHandle();
  var lastStatus = useRef(screen.active);
  var lastInteraction = useRef({});
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    landscapeMobile = _useContext.landscapeMobile;
  var fullScreenActive = useCallback(() => screen.active, [screen.active]);
  var fullscreenEnabled = () => fscreen.fullscreenEnabled;
  useEffect(() => {
    // Only send the event if we've actually left fullscreen, not on the first render.
    if (screen.active !== lastStatus.current) {
      if (screen.active) {
        sendEvent('carousel-fullscreen', {
          buttonClick: !lastInteraction.current.autoFullscreen
        });
      } else {
        sendEvent('carousel-leave-fullscreen', {
          buttonClick: Boolean(lastInteraction.current.exitButtonClicked)
        });
      }
      lastInteraction.current = {};
    }
    lastStatus.current = screen.active;
  }, [screen.active, sendEvent]);
  var enterFullScreen = function enterFullScreen() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      auto = _ref.auto;
    if (fullscreenEnabled()) {
      lastInteraction.current.autoFullscreen = auto;
      screen.enter();
    }
  };
  var exitFullScreen = () => {
    if (fullscreenEnabled()) {
      lastInteraction.current.exitButtonClicked = true;
      screen.exit();
    }
  };
  var layout = useMemo(() => ({
    // We enable the thumbnails if we're full screen or if we're not on a mobile.
    thumbnails: !(mobile || landscapeMobile && !fullScreenActive()),
    // We don't want nav buttons on either portrait or lanscape mobile
    modalNavButtons: !mobile && !landscapeMobile
  }), [mobile, landscapeMobile, fullScreenActive]);
  var fullScreen = {
    isActive: fullScreenActive,
    isEnabled: fullscreenEnabled,
    enter: enterFullScreen,
    exit: exitFullScreen,
    handle: screen
  };
  return {
    layout,
    fullScreen
  };
};
export default useScreenLayout;